import { z } from 'my-zod'
import { transferSystemView } from './transfer-system-view'

export const transferAdminView = transferSystemView.augment({
  batch: z.number()
})
export type transferAdminView = z.infer<typeof transferAdminView>
